export const gradients = {
  bluePurple: {
    main: 'linear-gradient(208.56deg, #2D64EF 0.63%, #8E2DEF 100%)',
  },
};
